import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryEquipmentActions } from "../../../../store/external/inventory/equipment.reducer";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import "../../../common/report/reports/Invoice/invoice-table.component.css";
import '../../inventory/inventory-component.css';
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DetailsLayout } from "../../../common/Layout/details";
import { default as EquipmentForm } from '../../../../components/external/inventory/equipment/equipment-form/form-view.component';

import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { default as EquipmentHistory } from "../../../../components/external/inventory/equipment/equipment-history/equipment-history-container.component";
import { Selected_Index, MODAL_TITLE, EQUIPMENT_MSG, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import EquipmentComment from "./equipment-comment/equipment-comment.component";
import { Loading } from "../../../common/loading";
import { TRANSLATIONS as translation } from "../../../../utils/constant.utils";
class InventoryEquipment extends Component {
    constructor(props) {
        super(props);
        this.DisplaySearhBox = this.DisplaySearhBox.bind(this)

        this.state = {
            headerTitle: 'Equipment',
            modifyColTitle: '',
            extractInventoryTitle: '',
            searchTitle: '',            
            tableSelected: false,
            closeForm: false,
            rowId: "0",
            pageNumber: 0,
            viewType: 'list',
            displaySearch: false,
            selectedIndex: 0,
            dataSelected: [],
            viewDetailPage: false,
            selectedTab: Selected_Index.i_Zero,
            createNew: false,
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Comments",
                    "hidden": false,
                    "disable": true
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "History",
                    "hidden": false,
                    "disable": true
                }
            ],
            pages: {
                "PageNumber": 0,
                "PerPage": 10,
                "TotalPages": 2,
                "TotalEntries": 11,
                "HasNext": true,
                "HasPrevious": false,
                "PageSizes": [
                    10,
                    20,
                    30
                ]
            }
        }
    }

    componentDidMount() {
        this.getEquipmentDetails();
    }

    componentWillUnmount = async () => {
        await this.props.resetInventoryEquipmentData();
         await this.props.setResetSearch();
    }

    getEquipmentDetails() {
        const { getEquipmentdropDownList} = this.props
        this.props.getInventoryEquipment();
        this.changeHeaderTitle();
        getEquipmentdropDownList();
    }

    DisplaySearhBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    openLineItem(data) {
        this.setState({ tableSelected: data })
    }

    CloseForm(data) {
        this.setState({ tableSelected: data })
    }

    getDataSelected(data) {
        this.setState({ selectedIndex: data })

    }

    resizePage = (value) => {
        const { getInventoryEquipment, resizeInventoryEquipmentPage } = this.props;
        resizeInventoryEquipmentPage(value);
        getInventoryEquipment();
    }

    toLocaleLanguage = (key) => {
                const { locale } = this.props;
                if (locale === null || locale === '' || locale === undefined)
                    return translation[translation['defaultLocaleLanguage']][key];
        
                return translation[locale][key];
    }

    onClickExtract = (e) => {
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            this.props.extractInventoryEquipments();
        }
    };

    applyFilter = (isApply) => {
        const { getInventoryEquipment, applyInventoryEquipmentFilter } = this.props;
        applyInventoryEquipmentFilter(isApply);
        isApply && getInventoryEquipment(0);
        
    }

    reloadInventoryEquipment = () => {
        const { getInventoryEquipment} = this.props;
        this.setState({ viewDetailPage: false, createNew: false, headerTitle: "equipment" })
        getInventoryEquipment();      
    }

    getData = (isShow, rowItem) => {  
        
        const { getInventoryEquipmentDetailsById} = this.props;

        if (rowItem != null) {
            var equipmentId = rowItem.EquipmentId;

            this.setState({ 
                viewDetailPage: isShow
                , equipmentId: rowItem.EquipmentId
                , selectedEquipment: rowItem
            })

            this.setState({ viewDetailPage: isShow },()=>(
                this.changeHeaderTitle()
            ))
            getInventoryEquipmentDetailsById(equipmentId);          
        }
        else {
            this.setState({ viewDetailPage: isShow })
            this.changeHeaderTitle()
        }
        
    }

    changeHeaderTitle = () =>{
        if(this.state.viewDetailPage) {
            this.setState({headerTitle:"equipment_details"})
        } else {
            this.setState({headerTitle:"equipment"})
        }
    }

    closeForm = () =>{
        this.setState({viewDetailPage: false, createNew: false, selectedTab: Selected_Index.i_Zero}, () =>(
            this.changeHeaderTitle()
        ));
        this.getEquipmentDetails();
    }
    renderTabContent = (index) =>{
        this.setState({selectedTab: index});
    }
    handelCreateNew(){        
        this.setState({
            showModal: true,
        })
     }

    handleConfirmationModal(buttonType){
        if(buttonType==="ok")
        {
            this.props.getNewEquipmentInventoryForm();
            this.setState({createNew:!this.state.createNew, showModal: false, headerTitle:"equipment_details" })
        } else {
            this.setState({showModal: false })
        }
       
    }

    activeListTab = (listTab) => {
        const { inventoryEquipmentForm } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((parseInt(item.id) === parseInt(Selected_Index.i_One) || parseInt(item.id) === parseInt(Selected_Index.i_Two)) && (inventoryEquipmentForm && inventoryEquipmentForm.equipmentId > 0)) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    render() {
        const { inventoryEquipment, getInventoryEquipment, sortInventoryEquipmentItems, setInventoryEquipmentColSearchStr, addInventoryEquipmentFilter, removeInventoryEquipmentFilter, saveInventoryEquipmentCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.inventoryEquipment.inventoryEquipmentItems.Columns;

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitRW])

        return (
            <div className="invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle={this.state.headerTitle} />
                <ConfirmationNotificationModal 
                    show={this.state.showModal} 
                    message={EQUIPMENT_MSG.CONFIRM_CREATE_MSG} 
                    title={MODAL_TITLE.ADD_NEW}
                    handleModal={this.handleConfirmationModal.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <div className="request-table data-table fit-width">
                    
                    {
                      this.state.viewDetailPage || this.state.createNew?
                                   <DetailsLayout 
                                    listTab={this.activeListTab(this.state.listTab)}
                                    handleClose={this.closeForm}
                                    renderTabContent={this.renderTabContent}
                                    urlIndex={this.state.selectedTab}
                                    showBackButton={true}
                                    >   
                                        {
                                            this.state.selectedTab === Selected_Index.i_Zero &&
                                            <EquipmentForm
                                                closeForm={this.reloadInventoryEquipment.bind(this)}
                                                createNew={this.state.createNew}
                                    
                                                //Access Type
                                                isReadAndWrite={isReadAndWrite}
                                            />
                                        }
                                        {
                                            this.state.selectedTab === Selected_Index.i_One &&
                                            <EquipmentComment
                                                equipmentId={this.state.equipmentId}
                                                
                                                //Access Type
                                                isReadOnly={isReadOnly}
                                                isReadAndExtractOnly={isReadAndExtractOnly}
                                                isReadAndWrite={isReadAndWrite}
                                            />
                                        }
                                        {
                                             this.state.selectedTab === Selected_Index.i_Two &&
                                            <EquipmentHistory
                                                pages={this.state.pages}
                                                equipmentId={this.state.equipmentId}
                                    
                                                //Access Type
                                                isReadOnly={isReadOnly}
                                                isReadAndExtractOnly={isReadAndExtractOnly}
                                                isReadAndWrite={isReadAndWrite}
                                            />
                                        }
                                    </DetailsLayout>
                            :
                            <>
                                    <DetailsDashboard
                                    // Filter Properties
                                    data={inventoryEquipment.inventoryEquipmentItems.TableFilterData} 
                                    translation={this.state.translation} addAction={addInventoryEquipmentFilter} 
                                    removeAction={removeInventoryEquipmentFilter} applyAction={this.applyFilter}

                                    //CreateNew Action
                                    createNewAction={this.handelCreateNew.bind(this)}

                                    //View Search Textbox
                                    viewSearchAction={this.DisplaySearhBox}

                                    //Customize Column
                                    firstList={Available} 
                                    secondList={Selected}
                                    defaultList={Default}
                                    saveAction={saveInventoryEquipmentCustomCols}

                                    //Extract Button
                                    extractAction={(e)=> this.onClickExtract(e)}
                                    
                                    //Access Type
                                    isReadOnly={isReadOnly}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                >
                                     {
                                        inventoryEquipment.isInventoryEquipmentLoaded && inventoryEquipment.isEquipmentdropDownListLoaded ?                           
                                            <TablePagination
                                                key={TABLE_PAGINATION_KEY.inventoryEquipment}
                                                tablePaginationKey={TABLE_PAGINATION_KEY.inventoryEquipment}
                                                classNameWrapper="overflow-auto" 
                                                columns={inventoryEquipment.inventoryEquipmentItems.Headers}
                                                pageList={inventoryEquipment.inventoryEquipmentItems.Data}
                                                pages={inventoryEquipment.inventoryEquipmentItems.Pagination}
                                                rowClickAction={(value) => {this.getData(true, value) }}
                                                paginationAction={getInventoryEquipment}
                                                onColumnClick={sortInventoryEquipmentItems}
                                                onColumnSearch={() => { getInventoryEquipment(0) }}
                                                onColumnSearchChange={setInventoryEquipmentColSearchStr}
                                                isColSearchShow={this.state.displaySearch}
                                                resizePage={this.resizePage}
                                            />
                                            : <Loading />
                                    }
                                </DetailsDashboard>
                            </>
                    }
                </div>
            </div>
        )
    }
}

export default connect(
    state => {
        const { inventoryEquipment, translation } = state;
        const { inventoryEquipmentForm } = state.form;
        return {
            inventoryEquipment,
            inventoryEquipmentForm,
            ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryEquipmentActions),
        dispatch
    )
)(InventoryEquipment);